/*
 * @Author: Teemo Ding
 * @Date: 2021-12-24 10:55:16
 * @LastEditTime: 2022-01-07 10:25:48
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/ProductsItems/OrderGiftTable.tsx
 */
import React from 'react';
import { get } from 'lodash';
import { SizeFittingTable, Image } from 'src/components/Antd';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';

import css from './css.module.less';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const widthDict = {
  productName: { minWidth: 221 },
  sku: { minWidth: 120 },
  qty: {
    width: 76,
  },
  subscriptionBuyName: { width: 260 },
};
const tableName = 'additionalItem';
const OrderGiftTable = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    value,
    //onChange, nonOperational
  } = props;

  const columns = [
    {
      title: getI18n('general.productName'),
      key: 'productName',
      dataIndex: 'productName',
      default: true,
      sorter: (a, b) => {
        const name1 = a.productName || '';
        const name2 = b.productName || '';
        const n1 = name1.toLowerCase();
        const n2 = name2.toLowerCase();
        if (n1 > n2) return 1;
        if (n2 > n1) return -1;
        return 0;
      },
      childGenerate: (text, record) => {
        // console.log('record', record);
        const { productName } = record;
        const thumbnailUrl = get(record, 'image.url');
        return (
          <div className={css.productNameContainer}>
            <Image
              style={{
                marginRight: 12,
              }}
              width={40}
              height={40}
              key={thumbnailUrl}
              src={thumbnailUrl}
              alt={thumbnailUrl}
            />

            <NoWrapContainer>
              <GlobalTooltip title={productName || '-'}>
                <div className={css.text}>{productName || '-'}</div>
              </GlobalTooltip>
            </NoWrapContainer>
          </div>
        );
      },
      ...widthDict['productName'],
    },
    {
      title: getI18n('general.sKU'),
      key: 'SKU',
      default: true,
      childGenerate: (text, record) => {
        const { sku } = record;
        return (
          <NoWrapContainer>
            <GlobalTooltip title={sku || '-'}>{sku}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['sku'],
    },
    {
      title: getI18n(
        'subscriptionBuy.subscriptionBuy.productItems_OrderGiftTable_columns_subname_title',
      ),
      key: 'subscriptionBuyName',
      dataIndex: 'subscriptionBuyName',
      default: true,
      //   childGenerate: (text, record) => {
      //     const { sku } = record;
      //     return (
      //       <NoWrapContainer>
      //         <GlobalTooltip title={sku || '-'}>{sku}</GlobalTooltip>
      //       </NoWrapContainer>
      //     );
      //   },
      ...widthDict['subscriptionBuyName'],
    },
    {
      title: getI18n(
        'subscriptionBuy.subscriptionBuy.productItems_OrderGiftTable_columns_QTY_title',
      ),
      key: 'QTY',
      default: true,
      //optional: false,
      //  className: css.tableCol,
      childGenerate: (text, record) => {
        const { amount } = record;

        return (
          <NoWrapContainer>
            <GlobalTooltip title={amount || '-'}>{amount}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['qty'],
    },
  ];

  return (
    <SizeFittingTable
      rowKey='uuid'
      pagination={false}
      dataSource={value}
      className={css.detailTable}
      id={tableName}
      columns={columns}
    />
  );
};

export default OrderGiftTable;
